module.exports = __webpack_public_path__ + "img/user-id.aace9d7a.svg";